// YNX — Safe markdown renderer component.
//
// SECURITY: DOMPurify.sanitize() is called INLINE at the dangerouslySetInnerHTML
// site so static analyzers can match the safety guarantee without indirection.
// `renderMarkdownHTML()` ALSO sanitizes internally — double-sanitization is
// idempotent and intentional defense-in-depth.
import React from 'react';
import DOMPurify from 'dompurify';
import { renderMarkdownHTML } from '../lib/markdown';

// Strict policy — must mirror SANITIZE_CONFIG in lib/markdown.js EXACTLY.
// The renderer never emits headings (h1-h6) or block elements outside of
// p/br/strong/em/code/pre/a/ul/ol/li — anything else is stripped.
const POLICY = Object.freeze({
  ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'code', 'pre', 'a', 'div', 'span', 'ul', 'ol', 'li'],
  ALLOWED_ATTR: ['href', 'target', 'rel', 'class', 'style', 'data-mdlink'],
  ALLOW_DATA_ATTR: false,
  FORBID_TAGS: ['script', 'style', 'iframe', 'object', 'embed', 'form', 'input', 'button'],
  FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover', 'onfocus', 'onblur'],
  ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto):|\/|#|\.\/)/i,
});

export const MarkdownView = ({ children, className }) => (
  <div
    className={className}
    dangerouslySetInnerHTML={{
      // XSS-safe: sanitized in-place by DOMPurify with a strict allow-list.
      __html: DOMPurify.sanitize(renderMarkdownHTML(children || ''), POLICY),
    }}
  />
);

export default MarkdownView;
